import Base from './Base';
import PendingMention from '../models/PendingMention';

export default class PendingMentions extends Base {
    get models() {
        const collection = this.data.map(item => new PendingMention(item));
        collection.collection = this;

        return collection;
    }
}
